<template>
    <div class="content">
        <div class="interview_box">
            <div class="interview_top_part">
                <div @click="handleInterviewClose" class="close_btn">×</div>
            </div>
            <div class="interview_content">
                <div class="roles">{{ person.role }}</div>
                <div class="careers">{{ person.career }}</div>
                <h2>{{ person.name }}<span class="area_name">【{{ person.area }}】</span></h2>
                <img :src="`/face/${person.face}`" alt="">

                <h3>プロフィール</h3>
                {{ person.prof }}
                <div v-if="person.message_for_mikeiken">
                    <h3>これからエンジニアを目指す皆様へ</h3>
                    {{ person.message_for_mikeiken }}
                </div>

                <div v-if="person.message_for_career">
                    <h3>すでにキャリアを積まれている方へ</h3>
                    {{ person.message_for_career }}
                </div>

            </div>
        </div>



    </div>
</template>
<script>

export default {
    name: "InterviewBox",
    props: ["person"],
    methods: {
        handleInterviewClose() {
            this.$emit("interview_close")
        }
    },
    computed: {

    }
}
</script>
<style>
.interview_box {
    width: 550px;
    height: auto;
    border: 2px solid black;
    border-radius: 10px;


    background-color: #fff;

    padding: 20px 20px 50px 20px;

}

.interview_content {
    text-align: center;
    line-height: 40px;
}

.interview_box h2 {
    margin: 0;
}

.interview_box h3 {
    margin: 30px;
}

.interview_content h5 {
    margin: -10px;
}

.interview_box img {
    width: 250px;
}

.interview_sub_title {
    font-size: 12px;
    font-weight: bold;
}

.close_btn {
    font-size: 20px;
    font-weight: bold;
    cursor: pointer;
    transition: 300ms;
}

.close_btn:hover {
    transition: 300ms;
    transform: scale(1.55)
}

.interview_top_part {
    width: 100%;
    display: flex;
    justify-content: flex-end;
}

.area_name {
    font-size: 15px;
}

.roles {
    font-size: 17px;
    font-weight: bold;
    margin-bottom: -10px;
}

.careers {
    font-size: 15px;
    font-weight: bold;
    margin-bottom: -10px;
}

@media(max-width:500px) {
    .interview_box {
        width: 300px;
        padding: 0;
    }
}
</style>